import { render, staticRenderFns } from "./content-link-ref.vue?vue&type=template&id=55e7a3f5"
import script from "./content-link-ref.vue?vue&type=script&lang=js"
export * from "./content-link-ref.vue?vue&type=script&lang=js"
import style0 from "./content-link-ref.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/link/content-link-ref.vue
// module id = FRTs
// module chunks = 0